import React from 'react';
// Importa el componente con el nuevo nombre
import DailyPortalOracleDeck from '../../components/oracle/DailyPortalOracleDeck';
import ThreeCardOracleSpread from '../../components/oracle/ThreeCardOracleSpread';
import ConsciousWarriorTracker from '../../components/oracle/ConsciousWarriorTracker';

const ConsciussWarriorPageEs = () => {
  const currentLang = 'es'; 

  return (
    <div className="bg-gray-900 min-h-screen pt-16">
      {/* Usa el componente con el nuevo nombre */}
      <ConsciousWarriorTracker lang={currentLang} />
    </div>
  );
};

export default ConsciussWarriorPageEs;